import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";

export default function CreationFormWrapper({
  open,
  onClose,
  onSubmit,
  error,
  title,
  subTitle,
  children,
  DialogProps,
  maxWidth = "xs",
  confirmText = "Add",
  cancelText = "Cancel",
}) {
  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    onSubmit(event);
  };
  return (
    <Dialog open={open} onClose={onClose} maxWidth={maxWidth} {...DialogProps}>
      <form onSubmit={handleSubmit}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          {subTitle && <DialogContentText>{subTitle}</DialogContentText>}
          {children}
          {error && (
            <Alert sx={{ mt: 1 }} severity="error">
              {error}
            </Alert>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>{cancelText}</Button>
          <Button type="submit">{confirmText}</Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
